export default "__VITE_ASSET__89e31c2f__"